import { AdvancedApiError } from '../api/client'
import { statusLabel } from '../api/failureReason'

// Admin wording: the reader can act on a status code and a missing migration, unlike a coach.
export const adminFailureReason = (error: unknown): string => {
  if (!(error instanceof AdvancedApiError)) {
    return 'Advanced isn’t responding.'
  }

  if (error.status === 401) {
    return 'Your session has no admin claim. Sign out and back in as an admin.'
  }

  if (error.status === 404) {
    return 'This Advanced service doesn’t have this setting yet: it’s older than this dashboard.'
  }

  return error.status >= 500
    ? `Advanced failed to answer (${error.status}). Its database may be missing the latest migration.`
    : `Advanced refused the request (${statusLabel(error)}).`
}

export const isRejected = (error: unknown): boolean => error instanceof AdvancedApiError && error.status < 500
